import { render, staticRenderFns } from "./DrawerLinks.vue?vue&type=template&id=057eb6f4"
import script from "./DrawerLinks.vue?vue&type=script&lang=js"
export * from "./DrawerLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports